import React, { useCallback, useState } from 'react';
import { Link, Redirect, Route, Switch, useHistory, useParams, useRouteMatch } from 'react-router-dom';
import styled, { createGlobalStyle } from 'styled-components';
import { sections, instruments, levels, songs, parts } from './data';

const GlobalStyle = createGlobalStyle`
  body {
    background-color: rgb(241, 243, 244);// #eee;
  }
`;

const AppContainer = styled.div`
  text-align: center;
  height: 100%;
`;

const Logo = styled.div`
  background-image: url('https://stanfordjazz.org/wp-content/uploads/2014/11/sjw-logos-web-horizontal_sjw-logo-web-horizontal-blue-on-white.png');
  height: 80px;
  padding-left: calc(360px + 5px);
  display: inline-block;
  background-repeat: no-repeat;
  text-align: left;
  font-family: Arial;
  font-weight: 800;

  width: 60px;
  word-wrap: normal;
  
  font-size: 20px;
  letter-spacing: 2px;
  padding-top: 25px;
  color: black;

  @media only screen and (max-width: 480px){
    background-size: 250px;
    padding-left: 0;
    width: 250px;
    height: auto;
    padding-top: calc((106/320)*250px);
    text-align: center;
  }
`;

const PartBtn = styled(Link)`
    display: inline-block;
    width: 150px;
    padding: 10px 12px;
    margin: 4px;
    background-color: #ddd;
    color: black;
    text-decoration: none;
    font-size: 1.2rem;
    display:flex;
    flex-direction:column;
    justify-content:space-around;

    ${ (p: {grow?: boolean}) => p.grow && `flex-grow: 1;`}
    height: 2rem;
`;

const FullWidth = styled.div`
  padding: 0 50px;
  margin-top: 100px;
  @media only screen and (max-width: 480px){
    margin-top: 25px;
    padding: 0 15px;
  }
`;
const FullWidthLeft = styled.div`
  text-align: left;
  padding: 0 50px;
  margin-top: 100px;
  @media only screen and (max-width: 480px){
    margin-top: 25px;
    padding: 0 15px;
  }
`;

const Warning = styled.div`
  position: fixed;
  top: 60px;
  right: 20px;
  width: 300px;
  color: red;
  z-index: 5;
`;

const GoAhead = styled.div`
  position: fixed;
  top: 60px;
  right: 20px;
  width: 300px;
  color: green;
  z-index: 5;
`;

const AudioPlayer = styled.audio`
  position: fixed;
  top: 20px;
  right: 20px;
  width: 300px;
  z-index: 1000;

  @media only screen and (max-width: 480px){
    top: unset;
    bottom: 5px;
    left: 50%;
    transform: translateX(-50%);
  }
`;
const BackButton = styled.button`
  display: inline-block;
  border-radius: 50%;
  position: fixed;
  top: 20px;
  left: 20px;

  @media only screen and (max-width: 480px){
    top: 5px;
    left: 50%;
    transform: translateX(-50%);
  }

  background-color: rgb(241, 243, 244);
  background-image: url(/back_img.png);
  background-repeat: no-repeat;
  background-size: 30px;
  background-position: center;
  height: 54px;
  width: 54px;
  border: none;
`;

const TBut = styled(BackButton)`
  background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='96px' height='215px' viewBox='0 0 96 215' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3EGroup%3C/title%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Group' transform='translate(8.000000, 0.000000)'%3E%3Cpath d='M0,0 C0,24.5939334 0,51.637907 0,81.1319208 C0,125.372942 24.5103681,137 40,137 C55.7573255,137 80,125.372942 80,81.1319208 C80,51.637907 80,24.5939334 80,0' id='Line' stroke='%23000000' stroke-width='15'%3E%3C/path%3E%3Cline x1='40' y1='137' x2='40' y2='197' id='Line-2' stroke='%23000000' stroke-width='15' stroke-linecap='square'%3E%3C/line%3E%3Ccircle id='Oval' fill='%23000000' cx='40' cy='201' r='14'%3E%3C/circle%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  background-size: 15px;
  left: calc(20px + 54px + 10px);

  ${(props: { pressed: boolean }) => props.pressed && `background-color: #bbb;`}
`;

const PDBut = styled(BackButton)`
  background-image: url(/pdf_download_img.png);
  background-size: 50px;
  left: calc(20px + 54px + 10px + 64px);
`;

const MDBut = styled(BackButton)`
  background-image: url(/mp3_download_img.png);
  background-size: 50px;
  left: calc(20px + 54px + 10px + 64px + 64px);
`;

const UBut = styled(BackButton)`
  background-image: url(/upload_img.png);
  background-size: 30px;
  left: calc(20px + 54px + 10px + 64px + 64px + 64px);
`;

const PBut = styled(BackButton)`
  background-image: url(/musicians.png);
  background-size: 30px;
  left: calc(20px + 54px + 10px + 64px + 64px + 64px + 64px);
`;

const IBut = styled(BackButton)`
  background-image: url(/question_mark.png);
  background-size: 30px;
  left: calc(20px + 54px + 10px + 64px + 64px + 64px + 64px + 64px);
`;

function TuningButton() {
  let [oscillatorNode, setOscillatorNode] = useState<OscillatorNode | null>(null);
  
  const toggle = useCallback(function toggle() {
    if (oscillatorNode) {
      // will auto-set the state
      oscillatorNode.stop();
      return;
    }

    let audioCtx = new AudioContext();
    let gainNode = audioCtx.createGain();
    gainNode.connect(audioCtx.destination);
    gainNode.gain.setValueAtTime(0, 0);
    gainNode.gain.linearRampToValueAtTime(0.2, audioCtx.currentTime + 0.6);
    

    let oscillator = audioCtx.createOscillator();
    oscillator.frequency.setValueAtTime(466.164, audioCtx.currentTime);
    oscillator.type = "square";
    oscillator.connect(gainNode);
    
    oscillator.start();
    oscillator.stop(20); // auto end the note in 20 sec if the user doesn't

    oscillator.onended = () => setOscillatorNode(null);
    setOscillatorNode(oscillator);
  }, [ oscillatorNode ]);

  return <TBut as="button" pressed={!!oscillatorNode} onClick={toggle} />;
}

const PartColumn = styled.div`
    display: flex;
    flex-direction: column;
    z-index: 1000;
`;

const VersionColumn = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-wrap: wrap;
    padding-left: 30px;
    padding-top: 25px;
`;

const NotesColumn = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-wrap: wrap;
    padding-right: 30px;
`;

const NotesBox = styled.div`
    height: 75px;
    padding-left: 30px;
`;

const MusiciansBox = styled.div`
  display: inline-block;
  position: fixed;
  top: 90px;
  left: 20px;
  background-color: rgb(241, 243, 244);
  background-position: center;
  width: 300px;
  border: none;
  border-radius: 25px;
`;

const InfoBox = styled.div`
  display: inline-block;
  position: fixed;
  top: 100px;
  left: 20px;
  background-color: rgb(241, 243, 244);
  background-position: center;
  height: 80%;
  width: 95%;
  border: none;
  border-radius: 25px;
  text-align: left;
  overflow-y:auto;
  padding: 20px;
`;

const Flexbox = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`;

function Welcome() {
  return <FullWidth>
    <FullWidthLeft>
    <h2>Welcome to SJW's placement evaluation player</h2><br />
    <h4>
      Play audio through a connected Bluetooth speaker or a wired speaker so that it's loud enough for us to hear along with your instrument.<br /><br />
      Record the sound of you playing your instrument as well as the sound of the backing track by recording them using another, separate device.<br /><br />
      Read the sheet music and instructions on screen, or download and print them at home.<br /><br />
      We require only one recording for placement. But if you'd like to submit two recordings, we'd love to hear them.<br /><br />

    </h4>
    </FullWidthLeft>
    <Flexbox>
      <PartBtn to={`/i`}>Get started &gt;</PartBtn>
    </Flexbox>
  </FullWidth>
}

function PickInstrument() {
  return <FullWidth>
    <h2>First, select your instrument.</h2>
    <Flexbox>
      {
        sections.map(({ type, instruments }) =>
          <PartColumn key={type}>
            <h3>{type}</h3>
            {instruments.map(i => 
            <PartBtn key={i.clean} to={`/i/${i.clean}`}>{i.name === "Piano" ? "Piano/Vibraphone" : i.name}</PartBtn>
            )}
          </PartColumn>
        )
      }
    </Flexbox>
  </FullWidth>
}

function PickSong() {
  const { instrument: instrumentParam } = useParams<{ instrument: string }>();
  const { url } = useRouteMatch();
  
  let instrument = instruments.find(i => i.clean === instrumentParam);
  if (!instrument) {
    return <Redirect to="/" />
  }
  
  return <FullWidth>
    <FullWidthLeft>
      <h2>Choose your level and one song to submit.</h2>
      {instrumentParam !== "drums" && <h3>Level 1: For first-time participants who have no experience improvising <br /><br />
          Level 2: You're comfortable with simple song forms and chord progressions <br /><br />
          Level 3: You're comfortable improvising in minor keys <br /><br />
          Level 4: You're comfortable with faster tempos and progressions that modulate <br /><br />
          Level 5: You like playing and soloing over challenging forms and progressions <br /><br />
          If you are under the age of 18 and auditioning for the Jazz Institute program, you must submit a song listed under Level 5 for your recording</h3>}
      {instrumentParam === "drums" && <h3>Level 1: For first-time participants who have little or no experience improvising or playing jazz <br /><br />
          Level 2: You're comfortable playing over a medium swing 12-bar blues <br /><br />
          Level 3: You're comfortable playing and improvising over medium/up tempo 12-bar blues/AABA song forms <br /><br />
          Level 4: You're comfortable with an uptempo AABA song form <br /><br />
          Level 5: You like playing and soloing over uptempo challenging forms <br /><br />
          If you are under the age of 18 and auditioning for the Jazz Institute program, you must submit a song listed under Level 5 for your recording</h3>}
    </FullWidthLeft>
    <Flexbox>
      {instrumentParam !== "drums" &&
        levels.map(({ type, songs }) =>
          <PartColumn key={type}>
            <h3>{type}</h3>
            {songs.map(s => <PartBtn key={s.clean} to={`${url}/s/${s.clean}`}>{s.name}</PartBtn>)}
          </PartColumn>
        )    
      }
      {instrumentParam === "drums" &&
        levels.map(({ type, songs }) =>
          <PartColumn key={type}>
            <h3>{type}</h3>
            {songs.map(s => 
              (s.name === "Dorian's Lament" || s.name === "Blues By Five" || s.name === "Mr. PC" || s.name === "Big Bertha" || s.name === "Yardbird Suite" || s.name === "Fantasy in D") ? <PartBtn key={s.clean} to={`${url}/s/${s.clean}`}>{s.name}</PartBtn> : null
              )}
          </PartColumn>
        )    
      }
    </Flexbox>
  </FullWidth>
}

function PickPart() {
  const { song: songParam } = useParams<{ song: string }>();
  const { instrument } = useParams<{ instrument: string }>();
  const { url } = useRouteMatch();

  let song = songs.find(s => s.clean === songParam);
  if (!song) {
    return <Redirect to="/" />
  }

  if (instruments.every(i => i.clean !== instrument)) {
    return <Redirect to="/" />
  }
  
  return <FullWidth>
    <h2>Finally, choose the version of the song you want to play.</h2>
    <Flexbox>
      <VersionColumn>
        {/* <PartBtn id={"first"} key={"Practice-Track"} to={`${url}/p/${"Practice-Track"}`}> {'Practice with this'} </PartBtn> */}
        
        <PartBtn id={"first"}
          key={ 
            (song.clean === "big_bertha" || song.clean === "blues_by_five" || song.clean === "mr_pc" || song.clean === "song_for_my_father") ? 
              ((instrument === "piano" || instrument === "guitar") ? "Practice-Piano-Guitar"
              : instrument === "bass" ? "Practice-Bass"
              : instrument === "drums" ? "Practice-Drums" 
              : "Practice-Track")
            : (song.clean === "fantasy_in_d" || song.clean === "dorians_lament") ? 
              ( instrument === "drums" ? "Practice-Drums"
              : "Practice-Track")
            : song.clean === "jeannine"  ? 
              ( instrument === "bass" ? "Practice-Bass"
              : "Practice-Track")
            : (song.clean === "yardbird_suite" || song.clean === "whisper_not") ? 
              ( instrument === "drums" ? "Practice-Drums"
              : instrument === "bass" ? "Practice-Bass"
              : "Practice-Track")
            : "Practice-Track"
          } 
          to={`${url}/p/${
            (song.clean === "big_bertha" || song.clean === "blues_by_five" || song.clean === "mr_pc" || song.clean === "song_for_my_father") ? 
              ((instrument === "piano" || instrument === "guitar") ? "Practice-Piano-Guitar"
              : instrument === "bass" ? "Practice-Bass"
              : instrument === "drums" ? "Practice-Drums" 
              : "Practice-Track")
            : (song.clean === "fantasy_in_d" || song.clean === "dorians_lament") ? 
              ( instrument === "drums" ? "Practice-Drums"
              : "Practice-Track")
            : song.clean === "jeannine"  ? 
              ( instrument === "bass" ? "Practice-Bass"
              : "Practice-Track")
            : (song.clean === "yardbird_suite" || song.clean === "whisper_not") ? 
              ( instrument === "drums" ? "Practice-Drums"
              : instrument === "bass" ? "Practice-Bass"
              : "Practice-Track")
            : "Practice-Track"
          }`}>
          {"Practice with this"}
        </PartBtn>
        
        <PartBtn 
          key={
            (instrument === "piano" || instrument === "guitar") ? "Piano-Guitar"
              : instrument === "Bass" ? "Bass"
              : instrument === "Drums" ? "Drums" 
              : "Melody"
          } 
          to={`${url}/p/${
            (instrument === "piano" || instrument === "guitar") ? "Piano-Guitar" 
              : instrument === "bass" ? "Bass"
              : instrument === "drums" ? "Drums" 
              : "Melody"
          }`}>
          {/* {(instrument === "piano" || instrument === "guitar") ? "Piano/Guitar" 
            : instrument === "bass" ? "Bass"
            : instrument === "drums" ? "Drums" 
            : "Record with this"
          } */}
          {"Record with this"}
        </PartBtn>
      </VersionColumn>
      <NotesColumn>
        <NotesBox>
          <h4>Practice with this: Use this for practice only. You'll hear parts doubling with you at times to help you learn the part and to help keep track of where you are in the song form. You'll be able to practice soloing. Please do not make your recording with this track.</h4>

          <h4>Record with this: This MP3 is for making your placement recording: You may not hear the part you're playing doubled in the MP3 file, but you will hear instruments playing the harmony parts. The track will reflect specific instructions for your instrument that you see on the sheet music, such as playing behind another soloist, or trading fours.</h4>
        </NotesBox>
      </NotesColumn>
    </Flexbox>
  </FullWidth>
}

const PlayPageContainer = styled.div`
  padding: calc(54px + 5px) 0;
  background-color: white;
  min-height: 100vh;
`;

const Score = styled.img`
  width: 100%;
  transition: opacity 2s;
  opacity: ${ (props: { loaded: boolean }) => props.loaded ? '1' : '0'};

  user-drag: none; 
  user-select: none;
`;

function Play() {
  const history = useHistory();
  const [musicianVisibility, setMusicianVisibility] = useState(false);
  const [infoVisibility, setInfoVisibility] = useState(false);

  let [scoreImageLoaded, setScoreImageLoaded] = useState(false);
  const { instrument: instrumentParam, song, part: partParam } = useParams<{ instrument: string, song: string, part: string }>();

  let instrument = instruments.find(i => i.clean === instrumentParam);
  let part = parts.find(i => i.clean === partParam);
  if (!instrument || songs.every(s => s.clean !== song) || !part) {
    return <Redirect to="/" />
  }

  let scoreSrc = `/assets/${instrument.key}/Displays/${song}.png`;
  let downloadScoreSrc = `/assets/${instrument.key}/Downloads/${song}.pdf`;

  const downloadScore = () => {
    fetch(downloadScoreSrc).then(response => {
      response.blob().then(blob => {
        const fileURL = window.URL.createObjectURL(blob);
        let alink = document.createElement('a');
        alink.href = fileURL;
        alink.download = song;
        alink.click();
      })
    })
  }

  // let MP3ScoreSrc = `/assets/${instrument.key}/Downloads/${song}.pdf`;
  let MP3ScoreSrc = (song === "dorians_lament" && part.clean === "Bass") ? `/audios/${song}/Melody.mp3` : `/audios/${song}/${part.clean}.mp3`;

  // {(song === "dorians_lament" && part.clean === "Bass") && <AudioPlayer autoPlay controls src={`/audios/${song}/Melody.mp3`} />}
  //   {!(song === "dorians_lament" && part.clean === "Bass") &&<AudioPlayer autoPlay controls src={`/audios/${song}/${part.clean}.mp3`} />}


  const downloadMP3 = () => {
    fetch(MP3ScoreSrc).then(response => {
      response.blob().then(blob => {
        const fileURL = window.URL.createObjectURL(blob);
        let alink = document.createElement('a');
        alink.href = fileURL;
        alink.download = song;
        alink.click();
      })
    })
  }

  let musicians = song === "dorians_lament" ? <h4>No artists to list for this recording; it's an AI band! </h4>
                : song === "song_for_my_father" ? <h4>SJW faculty artists playing on this recording:<br />JJ  Kirkpatrick, trumpet<br />Kristen Strom, tenor sax<br />Lemar Guillary, trombone<br />Bennett Paster, piano<br />Adi Meyerson, bass<br />Cory Cox, drums<br />Arrangement by Larry Dunlap, available in the Real Easy Book, Vol. 1, 3-horn edition, published by Sher Music.</h4>
                : song === "blues_by_five" ? <h4>SJW faculty artists playing on this recording:<br />JJ Kirkpatrick, trumpet<br /> Kristen Strom, tenor sax<br />Naomi Siegel, trombone<br />Bennett Paster, piano<br />Noah Garabedian, bass<br />Cory Cox, drums<br />Arrangement by Larry Dunlap, available in the Real Easy Book, Vol. 1, 3-horn edition, published by Sher Music.</h4>
                : song === "mr_pc" ? <h4>SJW faculty artists playing on this recording:<br />Markus Howell, alto sax<br />Kushal Talele, tenor sax<br />Natalie Cressman, trombone<br />Bennett Paster, piano<br />Noah Garabedian, bass<br />John Sturino, drums<br />Arrangement by Larry Dunlap, available in the Real Easy Book, Vol. 1, 3-horn edition, published by Sher Music.</h4>
                : song === "big_bertha" ? <h4>SJW faculty artists playing on this recording:<br />JJ  Kirkpatrick, trumpet<br />Kushal Talele, tenor sax<br />Lemar Guillary, trombone<br />Paul Cornish, piano<br />Adi Meyerson, bass<br />John Sturino, drums<br />Arrangement by Larry Dunlap, available in the Real Easy Book, Vol. 1, 3-horn edition, published by Sher Music.</h4>
                : song === "jeannine" ? <h4>SJW faculty artists playing on this recording:<br />Markus Howell, alto sax<br />Kristen Strom, tenor sax<br />Lemar Guillary, trombone<br />Paul Cornish, piano<br />Adi Meyerson, bass<br />Cory Cox, drums<br />Arrangement by Larry Dunlap, available in the Real Easy Book, Vol. 1, 3-horn edition, published by Sher Music.</h4>
                : song === "yardbird_suite" ? <h4>SJW faculty artists playing on this recording:<br />Markus Howell, alto sax<br />Kushal Talele, tenor sax<br />Lemar Guillary, trombone<br />Paul Cornish, piano<br />Adi Meyerson, bass<br />John Sturino, drums<br />Arrangement by Larry Dunlap, available in the Real Easy Book, Vol. 1, 3-horn edition, published by Sher Music.</h4>
                : song === "whisper_not" ? <h4>SJW faculty artists playing on this recording:<br />JJ Kirkpatrick, trumpet<br />Kushal Talele, tenor sax<br />Lemar Guillary, trombone<br />Paul Cornish, piano<br />Adi Meyerson, bass<br />John Sturino, drums<br />Arrangement by Larry Dunlap, available in the Real Easy Book, Vol. 1, 3-horn edition, published by Sher Music.</h4>
                : song === "fantasy_in_d" ? <h4>SJW faculty artists playing on this recording:<br />JJ Kirkpatrick, trumpet<br />Kushal Talele, tenor sax<br />Natalie Cressman, trombone<br />Paul Cornish, piano<br />Noah Garabedian, bass<br />Cory Cox, drums<br />Arrangement by Larry Dunlap, available in the Real Easy Book, Vol. 1, 3-horn edition, published by Sher Music.</h4>
                : "not found";

  return <PlayPageContainer>
    <BackButton onClick={ () => history.goBack() } />
    <TuningButton />
    <PDBut onClick={ () => downloadScore() } />
    <MDBut onClick={ () => downloadMP3() } />
    <UBut onClick={ () => window.open('https://registration.stanfordjazz.org/login/') } />
    <PBut onClick={ () =>  setMusicianVisibility(!musicianVisibility)} />
    {musicianVisibility && 
      <NotesColumn>
        <MusiciansBox>
          <h4> {musicians} </h4>
        </MusiciansBox>
      </NotesColumn>
    }
    {infoVisibility && 
      <NotesColumn>
        <InfoBox>
          <h3>Questions? Email Steven Lugerner at slugerner@stanfordjazz.org</h3>
          <h4>If the melody of any tune goes higher or lower than you can play on your instrument, transpose those out-of-range notes up or down an octave, so you can play them. </h4>
          
          <h3>Record your placement audition - the easy way</h3>
          <ul>
            <li> Read the music on the screen and play the audio on one device, while recording the sound on another device.</li>
            <li>Make sure we can hear your playing as well as the backing track.</li>
            <li>Upload the recording to your SJW account.</li>
          </ul>
          
          <h3>If you can't view the music on the screen:</h3>
          <ul>
            <li>Click the Download PDF button, download the music, print it out, and put it on a music stand where you can see it clearly.</li>
            <li>Play the backing track on one device, while recording the sound on another device.</li>
            <li>Make sure we can hear your playing as well as the backing track.</li>
            <li>Upload the recording to your SJW account.</li>
          </ul>

          <h3>Record your placement audition - using your own recording software</h3>
          <ul>
            <li>Click the Download MP3 button to download the backing track.</li>
            <li>Import the MP3 into your recording software.</li>
            <li>Record your playing into your software, and mix the two tracks.</li>
            <li>Export the audio as MP3 and upload it to your SJW account.</li>
          </ul>
          

          <h3>Music instruction explanations:</h3>
            <em>Melody/head:</em> In jazz music, we call the melody the "head".<br />
            <em>1X, 2X, 3X, etc:</em> 1X means "on the first time through the song form," 2X means "on the second time through the song form", and so on. If your instructions say "1x play melody, 2x & 3x improvise solo, 4x play the melody," this means to play the melody on the first time through, take a solo on the second and third time through, and play the melody on the fourth time through.<br />
            <em>Play shout chorus:</em> The shout chorus is a fun extra melody that you play before you play the head the final time.<br />
            <em>Comp:</em> For guitarists and pianists, this indicates that you should play chords to support a soloist. Play your chords rhythmically, using the chord symbols on the sheet music.
        </InfoBox>
      </NotesColumn>
    }
    
    <IBut onClick={ () =>  setInfoVisibility(!infoVisibility)} />
    {console.log("song=" + song + ", part.clean=" + part.clean)}
    {(song === "dorians_lament" && part.clean === "Bass") && <AudioPlayer autoPlay controls src={`/audios/${song}/Melody.mp3`} />}
    {!(song === "dorians_lament" && part.clean === "Bass") &&<AudioPlayer autoPlay controls src={`/audios/${song}/${part.clean}.mp3`} />}
    {((partParam === "Practice-Track") || (partParam === "Practice-Piano-Guitar") || (partParam === "Practice-Bass") || (partParam === "Practice-Drums")) && <Warning><h4>Playing Practice Track - do not record with this one</h4></Warning>}
    {((partParam !== "Practice-Track") && (partParam !== "Practice-Piano-Guitar") && (partParam !== "Practice-Bass") && (partParam !== "Practice-Drums")) && <GoAhead><h4>Playing Recording Track</h4></GoAhead>}
    <Score src={scoreSrc} alt="Score" loaded={scoreImageLoaded} onLoad={ () => setScoreImageLoaded(true) }/>
  </ PlayPageContainer>;
}

function Header() {
  return <Link to="/"><Logo>Pick Your Mix</Logo></Link>;
}

function App() {
  return <AppContainer>
    <GlobalStyle />
    <Switch>
      <Route exact path="/i/:instrument/s/:song/p/:part" />
      <Route path="/" component={Header} />
    </Switch>
    <Switch>
      <Route exact path="/" component={Welcome} />
      <Route exact path="/i" component={PickInstrument} />
      <Route exact path="/i/:instrument" component={PickSong} />
      <Route exact path="/i/:instrument/s/:song" component={PickPart} />
      <Route exact path="/i/:instrument/s/:song/p/:part" component={Play} />
    </Switch>
  </AppContainer>
}

export default App;
